import { IModel } from '@/@types/models/model';
import coreFields from '../helpers/coreFields';

const PrateceGradevine: IModel = {
  title: 'Pratece gradevine',
  apiPath: 'groblja/pratece-gradevine',
  layer: 'groblja_pratece_gradevine',
  forms: {
    default: {
      fields: [
        'groblje_id',
        'vrsta_id',
        'naziv'
      ],
    },
  },
  listViews: {
    default: {
      fields: [
        'id',
        'naziv',
        'groblje_id',
        'vrsta_id',
        'docs'
      ],
      hidden: ['id'],
    },
  },
  fields: [
    coreFields.id,
    {
      title: 'groblje_id',
      source: 'groblje_id',
      ttoken: 'groblja:grobna_mjesta.groblje',
      type: 'picker',
      subModel: {
        apiPath: 'groblja?view=picker',
        format: '{label}',
        idattr: 'id',
      },
      validation: {
        required: true,
      },
      filter: true,
    },
    {
      title: 'vrsta_id',
      source: 'vrsta_id',
      ttoken: 'groblja:pratece_gradevine.vrsta',
      type: 'picker',
      subModel: {
        apiPath: 'groblja/pratece-gradevine/vrste',
        format: '{label}',
        idattr: 'id',
      },
      filter: true,
    },    
    {
      title: 'naziv',
      source: 'naziv',
      ttoken: 'groblja:pratece_gradevine.naziv',
      type: 'text',
      filter: true,
    },
    coreFields.geom,
    coreFields.gid,
    coreFields.docs,
    coreFields.created_by,
    coreFields.created_on,
    coreFields.modified_by,
    coreFields.modified_on,
  ],
};

export default PrateceGradevine;
